module.exports = new __parcel__URL__("warning.38736678.svg").toString();